import React from 'react';
import {
  Box,
  Container,
  Heading,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Text,
} from '@chakra-ui/react';
import {
  SECTION_TITLE_CONTAINER_BG,
  SECTION_TITLE_TEXT_COLOR,
} from './constants';

const buildInfoUtili = (prezzoFratelli, prezzoMVP) => [
  {
    id: 'cosa-portare',
    title: 'Cosa Portare',
    content: (
      <>
        <Text mb={2}>
          Per vivere al meglio le giornate con noi, ecco alcune cose utili da
          portare:
        </Text>
        <Text fontWeight="bold" mb={2}>
          Essenziali da mettere nello zaino:
        </Text>
        <Box as="ul" pl={5} mb={2}>
          <li>Cappellino – Per proteggerti dal sole.</li>
          <li>Borraccia – Ti consigliamo di portarla già piena!</li>
          <li>Crema solare e spray antizanzare.</li>
          <li>
            Un cambio completo – Può sempre servire dopo i giochi
            all&apos;aperto.
          </li>
          <li>
            Per le attività con l&apos;acqua: Costume, ciabatte e asciugamano.
          </li>
        </Box>
      </>
    ),
  },
  {
    id: 'pasti',
    title: 'I Pasti',
    content: (
      <>
        <Text fontWeight="bold" mb={2}>
          Pranzo al Centro Estivo:
        </Text>
        <Box as="ul" pl={5} mb={2}>
          <li>Pranzo al sacco – Portato da casa.</li>
          <li>
            Pasti dal &quot;Nascondiglio di Chieri&quot; – Su prenotazione (5€).
            Puoi ordinarli entro le 9:30 del giorno stesso.
          </li>
        </Box>
        <Text fontWeight="bold" mb={2}>
          Merende:
        </Text>
        <Text mb={2}>
          Due merende (mattina e pomeriggio). Consigliamo posate riutilizzabili.
        </Text>
        <Text fontWeight="bold" mb={2}>
          Conservazione:
        </Text>
        <Text>
          Frigorifero e microonde disponibili; consigliamo contenitori ermetici.
        </Text>
      </>
    ),
  },
  {
    id: 'sostegno',
    title: 'Sostegno alle Famiglie',
    content: (
      <>
        <Text mb={2}>
          Vogliamo che ogni bambino viva un&apos;estate serena e inclusiva. Per
          esigenze particolari siamo qui.
        </Text>
        <Text fontWeight="bold" mb={2}>
          Supporto per:
        </Text>
        <Box as="ul" pl={5}>
          <li>Bambini con DSA o BES.</li>
          <li>Adattamenti e assistenza personalizzata.</li>
          <li>Ogni esigenza speciale: contattaci!</li>
        </Box>
      </>
    ),
  },
  {
    id: 'pagamenti',
    title: 'Pagamenti',
    content: (
      <>
        <Text mb={2}>
          Pagamento solo online (carta, PayPal, Satispay o Google Pay) per le
          iscrizioni. Per pagamenti diversi passare in sede.
        </Text>
        <Text fontWeight="bold" mb={2}>
          Opzioni:
        </Text>
        <Box as="ul" pl={5} mb={2}>
          <li>Acconto – Per confermare.</li>
          <li>Saldo – Entro il venerdì prima della settimana.</li>
          <li>Totale – Unico pagamento.</li>
        </Box>
        <Text fontWeight="bold" mb={2}>
          Sconti:
        </Text>
        <Box as="ul" pl={5} mb={2}>
          <li>
            Sconto fratelli – {prezzoFratelli}€/settimana per secondo figlio e
            successivi.
          </li>
          <li>
            MVP – Tutte le settimane a {prezzoMVP}€ (tutte selezionate,
            pagamento totale).
          </li>
        </Box>
      </>
    ),
  },
];

const InfoSection = ({ event, hideTitle }) => {
  const prezzoSettimana =
    event?.Varianti?.[0]?.prezzoVariante ?? event?.prezzo ?? 120;
  const scontoFratelli = event?.Sconto_Fratelli ?? 20;
  const prezzoFratelli = prezzoSettimana - (Number(scontoFratelli) || 0);
  const prezzoMVP =
    event?.Sconto_MVP != null && event?.Sconto_MVP !== ''
      ? Number(event.Sconto_MVP)
      : 700;
  const infoUtili = buildInfoUtili(prezzoFratelli, prezzoMVP);

  const content = (
    <Accordion allowToggle>
      {infoUtili.map((info) => (
        <AccordionItem key={info.id} mb={2}>
          <AccordionButton py={3}>
            <Text flex="1" textAlign="left" fontWeight="bold">
              {info.title}
            </Text>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel pb={4}>{info.content}</AccordionPanel>
        </AccordionItem>
      ))}
    </Accordion>
  );

  if (hideTitle) {
    return (
      <Container maxW="container.lg" px={{ base: 4, md: 6 }}>
        {content}
      </Container>
    );
  }

  return (
    <Box as="section" py={8}>
      <Container maxW="container.lg" px={{ base: 4, md: 6 }}>
        <Heading as="h2" size="lg" mb={6}>
          <Box
            display="inline-block"
            px={4}
            py={3}
            borderRadius="lg"
            sx={{ background: SECTION_TITLE_CONTAINER_BG }}
            boxShadow="sm"
          >
            <Text as="span" fontWeight="bold" color={SECTION_TITLE_TEXT_COLOR}>
              Informazioni pratiche
            </Text>
          </Box>
        </Heading>
        {content}
      </Container>
    </Box>
  );
};

export default InfoSection;
